import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LcsApiService } from '@lcs/shared/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { RestApiError } from 'src/app/common-components/errors/models/error-message';
import { UserPasswordResetModel } from '../models/user-password-reset.model';
import * as UserPasswordReset from './user-password-reset.actions';

@Injectable()
export class UserPasswordResetEffects {
   submitUserPasswordReset = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPasswordReset.userPasswordResetSubmitted),
         exhaustMap((action) => {
            const userPasswordReset: UserPasswordResetModel = action.userPasswordReset;
            return this.sendPasswordReset(userPasswordReset).pipe(
               map(() => {
                  return UserPasswordReset.userPasswordResetSuccess();
               }),
               catchError((error: RestApiError) => {
                  return of(UserPasswordReset.userPasswordResetFailure(error));
               })
            );
         })
      );
   });

   userPasswordResetSucess = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(UserPasswordReset.userPasswordResetSuccess),
            tap(() => {
               this.snackBar.open('Account password has been reset!');
               this.router.navigate(['login']);
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private apiService: LcsApiService,
      private router: Router,
      private snackBar: MatSnackBar,
      private httpClient: HttpClient
   ) {}

   private sendPasswordReset(userPasswordReset: UserPasswordResetModel) {
      return this.httpClient.post<void>(this.apiService.apiUrl + '/users/passwordreset', userPasswordReset, {
         observe: 'response',
      });
   }
}
